// One owner-scoped renderer. CSS owns first-paint and settled PNG positions.
function initHero(host){
if(!host?.matches('[data-bv-desktop-home]'))return;
const option1=host.hasAttribute('data-bv-option1');
const hero = host.closest('.bv-hero');
if(!hero)return;
const owner=host.closest('.bv-home').id;
const registry=window.BraventHeroOption1Controllers||(window.BraventHeroOption1Controllers=new Map());
registry.get(owner)?.();
let THREE,stopped=false;
const abort=new AbortController();
const listen=(node,event,fn)=>node.addEventListener(event,fn,{signal:abort.signal});
const desktop = matchMedia(option1?'(min-width:0px)':'(min-width:991px)');
const reduced = matchMedia('(prefers-reduced-motion:reduce)');
let renderer, camera, scene, child, keyboard;
let width=0, height=0, active=false, t0=0, frameId=0, frames=0;
const qa=new URLSearchParams(location.search).has('qa');
const layers=[];
const target={x:0,y:0}, pointer={x:0,y:0};
let loader, starting=false;

function bitmap(url){return loader.loadAsync(url).then(map=>{map.colorSpace=THREE.SRGBColorSpace;map.anisotropy=4;return map;});}
function illustration(map,name){
 const mesh=new THREE.Mesh(new THREE.PlaneGeometry(1,1),new THREE.MeshBasicMaterial({map,transparent:true,alphaTest:.02,depthWrite:false,side:THREE.DoubleSide}));
 mesh.name=name;mesh.userData.aspect=map.image.width/map.image.height;scene.add(mesh);return mesh;
}
function keycap(letter){
 const shape=new THREE.Shape();const s=.5,r=.12;
 shape.moveTo(-s+r,-s);shape.lineTo(s-r,-s);shape.quadraticCurveTo(s,-s,s,-s+r);shape.lineTo(s,s-r);shape.quadraticCurveTo(s,s,s-r,s);shape.lineTo(-s+r,s);shape.quadraticCurveTo(-s,s,-s,s-r);shape.lineTo(-s,-s+r);shape.quadraticCurveTo(-s,-s,-s+r,-s);
 const geometry=new THREE.ExtrudeGeometry(shape,{depth:.24,bevelEnabled:true,bevelThickness:.04,bevelSize:.04,bevelSegments:2,steps:1});
 const key=new THREE.Group();key.name='key-'+letter;
 key.add(new THREE.Mesh(geometry,[new THREE.MeshStandardMaterial({color:0x223852,roughness:.75,metalness:.12}),new THREE.MeshStandardMaterial({color:0x9a815f,roughness:.8})]));
 const text=document.createElement('canvas');text.width=128;text.height=128;
 const ctx=text.getContext('2d');ctx.fillStyle='#f1c994';ctx.font='600 80px Arial';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(letter,64,70);
 const texture=new THREE.CanvasTexture(text);texture.colorSpace=THREE.SRGBColorSpace;
 const front=new THREE.Mesh(new THREE.PlaneGeometry(.75,.75),new THREE.MeshBasicMaterial({map:texture,transparent:true,depthWrite:false}));front.position.z=.29;key.add(front);scene.add(key);return key;
}
function place(obj,x,y,w,z,depth,phase){obj.position.set(x,y,z);obj.scale.set(w,obj.userData.aspect?w/obj.userData.aspect:w,w);obj.userData={...obj.userData,baseX:x,baseY:y,depth,phase};if(!layers.includes(obj))layers.push(obj);}
function resize(){
 if(stopped)return;
 if(!option1){legacyResize();return;}
 const header=document.querySelector(".header-outer.overlayed_header .header_wrapper");
 if(header){const reserved=header.parentElement.offsetHeight;hero.style.setProperty("--bv-desktop-header-clearance",Math.max(0,header.offsetHeight-reserved)+"px");}
 width=host.clientWidth;height=host.clientHeight;
 const bounds=host.getBoundingClientRect();
 const layout=[
  {selector:'.bv-desktop-fallback:not(.bv-desktop-fallback--keyboard)',mesh:child,z:20,depth:10,phase:.8},
  {selector:'.bv-desktop-fallback--keyboard',mesh:keyboard,z:40,depth:12,phase:2.6}
 ].map(item=>{const r=host.querySelector(item.selector).getBoundingClientRect();return {...item,x:r.left-bounds.left+r.width/2,y:height-(r.top-bounds.top+r.height/2),w:r.width};});
 host.dataset.layoutReady='true';
 if(!renderer||!child||!keyboard)return;
 renderer.setSize(width,height);camera.left=0;camera.right=width;camera.top=height;camera.bottom=0;camera.updateProjectionMatrix();
 layout.forEach(item=>place(item.mesh,item.x,item.y,item.w,item.z,item.depth,item.phase));
 const caps=layers.filter(x=>x.name.startsWith('key-'));
 const positions=[[.06,.48,60,10],[.91,.91,85,12],[.94,.10,75,10]],size=width<400?34:46;
 // Bound the complete beveled key, pointer travel and bobbing inside the canvas.
 caps.forEach((k,i)=>{const [x,y,z,d]=positions[i],edgeX=size*.84+d+2,edgeY=size*.84+d*.45+6;place(k,Math.max(edgeX,Math.min(width-edgeX,width*x)),Math.max(edgeY,Math.min(height-edgeY,height*y)),size,z,d,i*1.7);k.rotation.set(.2,-.3,i===1?-.19:.16);});
 if(qa)host.dataset.artBounds=JSON.stringify({left:bounds.left,right:bounds.right,copyRight:hero.querySelector('.bv-hero-copy').getBoundingClientRect().right});
 render(0);
}
function legacyResize(){
 if(!desktop.matches)return;
 const header=document.querySelector(".header-outer.overlayed_header .header_wrapper");
 if(header){const reserved=header.parentElement.offsetHeight;hero.style.setProperty("--bv-desktop-header-clearance",Math.max(0,header.offsetHeight-reserved)+"px");}
 const background=host.querySelector('.bv-desktop-background');
 if(background){const fit=Math.min(hero.clientWidth,hero.clientHeight*3,2172/Math.max(1,devicePixelRatio));background.style.width=fit+'px';background.style.height=fit/3+'px';if(qa)host.dataset.backgroundDpr=String(devicePixelRatio);}
 width=hero.clientWidth;height=hero.clientHeight;
 // The artwork shares a bounded stage to the right of the unchanged copy.
 const heroRect=hero.getBoundingClientRect(),copyRect=hero.querySelector('.bv-hero-copy').getBoundingClientRect();
 const copyRight=copyRect.right-heroRect.left;
 const artLeft=Math.max(copyRight+48,Math.min(width*.53,copyRight+144));
 const artRight=Math.min(width*.96,artLeft+1000),artWidth=artRight-artLeft;
 const layout=[
  {selector:'.bv-desktop-fallback:not(.bv-desktop-fallback--keyboard)',mesh:child,x:artLeft+artWidth*.52,y:height*.43,w:Math.min(artWidth*.94,height*.90),z:20,depth:10,phase:.8},
  {selector:'.bv-desktop-fallback--keyboard',mesh:keyboard,x:artLeft+artWidth*.28,y:height*.80,w:Math.min(artWidth*.54,height*.44),z:40,depth:12,phase:2.6}
 ];
 // Static PNGs and WebGL use one layout, including before textures load.
 for(const item of layout){
  const image=host.querySelector(item.selector);
  const aspect=Number(image.getAttribute('width'))/Number(image.getAttribute('height'));
  Object.assign(image.style,{left:(item.x-item.w/2)+'px',top:(height-item.y-item.w/aspect/2)+'px',right:'auto',width:item.w+'px',height:(item.w/aspect)+'px'});
 }
 host.dataset.layoutReady='true';
 if(!renderer||!child||!keyboard)return;
 renderer.setSize(width,height);camera.left=0;camera.right=width;camera.top=height;camera.bottom=0;camera.updateProjectionMatrix();
 layout.forEach(item=>place(item.mesh,item.x,item.y,item.w,item.z,item.depth,item.phase));
 const caps=layers.filter(x=>x.name.startsWith('key-'));
 const positions=[[.08,.54,50,60,10],[.90,.86,58,85,12],[.91,.12,54,75,10]];
 caps.forEach((k,i)=>{const [x,y,s,z,d]=positions[i];place(k,artLeft+artWidth*x,height*y,s,z,d,i*1.7);k.rotation.set(.2,-.3,i===1?-.19:.16);});
 if(qa)host.dataset.artBounds=JSON.stringify({left:artLeft,right:artRight,copyRight});
 render(0);
}
function render(time){
 if(!renderer)return;
 pointer.x+=(target.x-pointer.x)*.06;pointer.y+=(target.y-pointer.y)*.06;
 for(const obj of layers){const d=obj.userData;const wave=reduced.matches?0:Math.sin(time*.00065+d.phase);obj.position.x=d.baseX+(reduced.matches?0:pointer.x*d.depth);obj.position.y=d.baseY+(reduced.matches?0:pointer.y*d.depth*.45)+wave*(obj.name.startsWith('key-')?4:2);}
 renderer.render(scene,camera);
 host.dataset.motion=reduced.matches?'reduced':'active';
 if(qa){
  host.dataset.frames=String(++frames);
  host.dataset.bounds=JSON.stringify([child,keyboard].map(o=>({name:o.name,left:o.position.x-o.scale.x/2,right:o.position.x+o.scale.x/2,top:height-o.position.y-o.scale.y/2,bottom:height-o.position.y+o.scale.y/2})));
  if(frames===1){const gl=renderer.getContext(),pixels=new Uint8Array(renderer.domElement.width*renderer.domElement.height*4);gl.readPixels(0,0,renderer.domElement.width,renderer.domElement.height,gl.RGBA,gl.UNSIGNED_BYTE,pixels);let n=0;for(let i=3;i<pixels.length;i+=4)if(pixels[i]>0)n++;host.dataset.nonblankPixels=String(n);}
 }
}
function frame(time){frameId=0;if(!active)return;render(time-t0);frameId=requestAnimationFrame(frame);}
function syncAnimation(){active=!stopped&&desktop.matches&&!document.hidden;if(!active&&frameId){cancelAnimationFrame(frameId);frameId=0;}if(active&&!frameId&&child)frameId=requestAnimationFrame(frame);}
async function start(){
 if(renderer){syncAnimation();return;}
 if(stopped||!desktop.matches||starting)return;
 starting=true;
 resize();
 try{
  THREE=await import(host.dataset.three);if(stopped)return;loader=new THREE.TextureLoader();
  renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,preserveDrawingBuffer:true});renderer.setPixelRatio(Math.min(devicePixelRatio,2));renderer.outputColorSpace=THREE.SRGBColorSpace;host.append(renderer.domElement);
  scene=new THREE.Scene();camera=new THREE.OrthographicCamera(0,1,1,0,.1,2000);camera.position.z=1000;
  scene.add(new THREE.AmbientLight(0xffffff,2));const light=new THREE.DirectionalLight(0xffdfb0,3);light.position.set(-200,600,700);scene.add(light);
  const [kidMap,keyboardMap]=await Promise.all([bitmap(host.dataset.child),bitmap(host.dataset.keyboard)]);
  if(stopped){kidMap.dispose();keyboardMap.dispose();return;}
  child=illustration(kidMap,'child');keyboard=illustration(keyboardMap,'keyboard');
  for(const letter of ['R','M','E'])layers.push(keycap(letter));
  resize();host.dataset.ready='true';t0=performance.now();syncAnimation();
 }catch(e){if(!stopped){host.dataset.error=String(e);console.error('Desktop hero:',e);}}
}
listen(hero,'pointermove',e=>{const r=hero.getBoundingClientRect();target.x=(e.clientX-r.left)/r.width*2-1;target.y=-((e.clientY-r.top)/r.height*2-1);});
listen(hero,'pointerleave',()=>{target.x=0;target.y=0;});
listen(document,'visibilitychange',syncAnimation);
listen(desktop,'change',()=>{syncAnimation();start();resize();});
listen(reduced,'change',()=>{render(0);syncAnimation();});
const observer=new ResizeObserver(resize);observer.observe(host);
function cleanup(){stopped=true;abort.abort();observer.disconnect();if(frameId)cancelAnimationFrame(frameId);scene?.traverse(obj=>{obj.geometry?.dispose();const materials=Array.isArray(obj.material)?obj.material:[obj.material];materials.filter(Boolean).forEach(m=>{m.map?.dispose();m.dispose();});});renderer?.dispose();renderer?.domElement.remove();delete host.dataset.ready;registry.delete(owner);}
registry.set(owner,cleanup);
listen(document,'shopify:section:unload',event=>{if(event.detail?.sectionId===owner.replace('bravent-home-','')||event.target.contains(host))cleanup();});
start();
}
window.BraventHeroOption1Init=source=>source.querySelectorAll('[data-bv-desktop-home]').forEach(initHero);
if(!window.BraventHeroOption1Lifecycle){window.BraventHeroOption1Lifecycle=true;document.addEventListener('shopify:section:load',event=>window.BraventHeroOption1Init(event.target));}
window.BraventHeroOption1Init(document);

